/**
 * @generated SignedSource<<1418a4323fecd717b11a0c0f0eb776f4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrderEditTabs_order$data = {
  readonly " $fragmentSpreads": FragmentRefs<"EntityHistory_entity" | "OrderEditMain_order">;
  readonly " $fragmentType": "OrderEditTabs_order";
};
export type OrderEditTabs_order$key = {
  readonly " $data"?: OrderEditTabs_order$data;
  readonly " $fragmentSpreads": FragmentRefs<"OrderEditTabs_order">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OrderEditTabs_order",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OrderEditMain_order"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EntityHistory_entity"
    }
  ],
  "type": "Order",
  "abstractKey": null
};

(node as any).hash = "5232e002b085001180ddbe47066d0656";

export default node;
